import NavBar from '../components/NavBar/navBar';
import Footer from '../components/Footer/footer';
import LocationContent from '../components/PageContent/LocationContent/locationContent';

function Location() {
  return (
    <div className="app">
      <NavBar pageActive={3}/>
      <div className="page-content page-content-map">
        <LocationContent asPageTitle />
      </div>
      <Footer />
    </div>
  );
}

export default Location;
